import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
export default function NewsNav({ title, className, category }: any) {
    const { Link } = useGlobal();

    return (
        <section className={`${css.naver} ${className} cover`}>
            <div className="container">
                <div className="detail-nav">
                    <h2 className="left">{title}</h2>
                    <div className="right">
                        <ul>
                            <li className={category === 'newsroom' ? '' : 'active'}>
                                <Link href={`/news`} ariaLabel={title}>
                                    <span>{title}</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
